<template>
  <div class="backend">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">cloud & server development.</div>
          <!-- <p>My name is <span>Kennedy Baraka Konde</span>.</p> -->
          <p>
            For server side application development, I use the following
            technologies to build scalable and performant <span>apis</span> and
            web services.
          </p>
          <div class="technology">
            <div class="tech-title">Typescript</div>
            <div class="level l-70 react"></div>
            <div class="tech-title">Go</div>
            <div class="level l-70 go"></div>
            <div class="tech-title">Nodejs</div>
            <div class="level node l-90"></div>
            <div class="tech-title">Sql</div>
            <div class="level sql l-80"></div>
            <div class="tech-title">Mongodb</div>
            <div class="level mongo l-100"></div>
            <!-- <div class="tech-title">AWS</div>
            <div class="level aws l-50"></div> -->
            <div class="tech-title">Express</div>
            <div class="level node l-100"></div>
            <div class="tech-title">Fastify</div>
            <div class="level aws l-80"></div>
          </div>
        </div>
        <div class="col s12 m6 my">
          <img
            @dblclick="go"
            src="@/assets/vectors/server.svg"
            class="img-responsive swing"
            style="animation-delay: 2s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const go = () => {
      router.push("/login");
    };
    return {
      go,
    };
  },
};
</script>

<style scoped>
.backend {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
  text-transform: capitalize;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
.technology {
  padding: 15px;
  border-radius: 20px;
  background: rgb(253, 251, 251);
}
.tech-title {
  color: #333;
  padding: 4px;
  text-transform: capitalize;
}
.level {
  height: 5px;
  margin-bottom: 18px;
  border-radius: 50px;
}
.vue {
  background-color: rgb(38, 231, 86);
}
.react {
  background-color: rgb(67, 38, 231);
}
.sass {
  background-color: rgb(238, 71, 202);
}
.js {
  background-color: rgb(248, 252, 58);
}
.firebase {
  background-color: rgb(238, 101, 59);
}
.html {
  background-color: rgb(19, 19, 15);
}
.go {
  background-color: rgb(54, 209, 236);
}
.node {
  background-color: rgb(0, 0, 0);
}
.mongo {
  background-color: rgb(15, 194, 9);
}
.sql {
  background-color: rgb(155, 155, 155);
}
.aws {
  background-color: rgb(235, 221, 25);
}
.l-50 {
  width: 50%;
}
.l-70 {
  width: 70%;
}
.l-90 {
  width: 90%;
}
.l-80 {
  width: 80%;
}
.l-100 {
  width: 100%;
}
.my {
  margin-top: 70px;
}
</style>
